import { createContext, useContext } from 'react';
import { useAuthStatus } from '../hooks/useAuthStatus';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const authStatus = useAuthStatus();

  return (
    <UserContext.Provider value={authStatus}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
